import { Container } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";

import AppHelmet from "../../components/AppComponents/AppHelmet";
import AppPageHeader from "../../components/Headers/AppPageHeader";
import AppNavbar from "../../components/AppNavbar/AppNavbar";
import SharedRecordsPageCenter from "./SharedRecordsPageCenter";
import SharedPagesCenter from "./SharedPagesCenter";
import SharedViewsCenter from "./SharedViewsCenter";
import SharedRecordsCenter from "./SharedRecordsCenter";
import SharedDocumentsCenter from "./SharedDocumentsCenter";

const tabs = [
  {
    title: "Records",
    activeValue: "SharedRecords",
  },
  {
    title: "Record Pages",
    activeValue: "SharedRecordPages",
  },
  {
    title: "Views",
    activeValue: "SharedViews",
  },
  {
    title: "Pages",
    activeValue: "SharedPages",
  },
  {
    title: "Documents",
    activeValue: "SharedDocuments",
  },
];

type ShareCenterTabs = "Records" | "RecordPages" | "Views" | "Pages";

const SharingCenter = () => {
  const { tenantID, tab } = useParams();
  const navigate = useNavigate();

  const handleTabChange = (value: ShareCenterTabs) => {
    navigate(`/clouds/${tenantID}/settings/sharing-center/${value}`);
  };

  return (
    <>
      <AppHelmet title="Sharing Center - GrowthCloud.com" />
      <Container fluid>
        <div className="header">
          <div className="header-body">
            <AppPageHeader
              borderless={true}
              title="Sharing Center"
              description="Manage all the records, views, pages, record pages you shared or subscribed to in this Cloud"
            />
          </div>
        </div>
        <div className="mt--3">
          <AppNavbar tabs={tabs} activeTab={tab} onSelect={handleTabChange} />
          {tab === "SharedRecords" && <SharedRecordsCenter />}
          {tab === "SharedRecordPages" && <SharedRecordsPageCenter />}
          {tab === "SharedViews" && <SharedViewsCenter />}
          {tab === "SharedPages" && <SharedPagesCenter />}
          {tab === "SharedDocuments" && <SharedDocumentsCenter />}
        </div>
      </Container>
    </>
  );
};

export default SharingCenter;
